import { UserActionViewModelConfiguration } from '../../shared/model/user-action.model';

export enum AlertType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning'
}
export interface Alert {
    type: AlertType;
    message: string;
}

export interface Banner extends Alert {
    id?: string;
    icon?: string;
    mainAction: UserActionViewModelConfiguration;
    auxilliaryAction?: UserActionViewModelConfiguration;
}

export type BannerType =
    'defaultError'
    | 'defaultSuccess'
    | 'noAuthorizationOrActivation'
    | 'sendCancel'
    | 'validationFailure'
    | 'uploadFailure'
    | 'invalidEmailFailure'
    | 'sendFailure'
    | 'sendSuccess'
    | 'sendSuccessNoCustomerCopy'
    | 'validationErrors'
    | 'autocorrections'
    | 'wrongUploadDatatype'
    | 'wrongUploadFilesize'
    | 'accountActivationSuccess'
    | 'accountActivationFailure'
    | 'adminAccountActivationSuccess'
    | 'adminAccountActivationFailure'
    | 'passwordChangeSuccess'
    | 'passwordChangeFailure'
    | 'loginFailure'
    | 'registrationFailure'
    | 'loginUnauthorized'
    | 'exportFailure'
    | 'downloadFailure'
    | 'tooManyDataRows';
